import ServiceBase from "./ServiceBase"

const resource = "/users"

export default
	{
		authenticateUser(payload)
		{
			return ServiceBase.post("system/authenticate/user/", payload)
		},
		getUser(id)
		{
			return ServiceBase.get(resource + "/" + id)
		},
		updateUser(id, payload)
		{
			return ServiceBase.put(resource + "/" + id, payload)
		},
		getRecentItems(payload)
		{
			return ServiceBase.get(resource + "/recentitems" + (payload ? "/" + payload : ""))
		},
		getNotifications(onlyUnread, lastNotificationID)
		{
			return ServiceBase.get(resource + "/notifications/" + (lastNotificationID ? lastNotificationID : "0") + (onlyUnread ? "/true" : ""))
		}
	}